export { default as ServicePointsListPage } from "./service-points"
export { default as ServicePointsFormPage } from "./service-points-form"
